const DEVICON_BASE = 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons';

const TECHNOLOGY_IMAGE_BY_KEY: Record<string, string> = {
  html: '/images/HTML.svg',
  html5: '/images/HTML.svg',
  htmljavascript: '/images/HTML.svg',
  htmljavascriptai: '/images/HTML.svg',
  node: '/images/Node.js.png',
  nodejs: '/images/Node.js.png',
  react: '/images/React.png',
  vue: '/images/Vue.js.png',
  vuejs: '/images/Vue.js.png',
  angular: '/images/AngularJS.png',
  angularjs: '/images/AngularJS.png',
  next: `${DEVICON_BASE}/nextjs/nextjs-original.svg`,
  nextjs: `${DEVICON_BASE}/nextjs/nextjs-original.svg`,
  nuxt: `${DEVICON_BASE}/nuxtjs/nuxtjs-original.svg`,
  nuxtjs: `${DEVICON_BASE}/nuxtjs/nuxtjs-original.svg`,
  vite: `${DEVICON_BASE}/vitejs/vitejs-original.svg`,
  vitejs: `${DEVICON_BASE}/vitejs/vitejs-original.svg`,
  python: `${DEVICON_BASE}/python/python-original.svg`,
  python3: `${DEVICON_BASE}/python/python-original.svg`,
  django: `${DEVICON_BASE}/django/django-plain.svg`,
  flask: `${DEVICON_BASE}/flask/flask-original.svg`,
  fastapi: `${DEVICON_BASE}/fastapi/fastapi-original.svg`,
  go: `${DEVICON_BASE}/go/go-original-wordmark.svg`,
  golang: `${DEVICON_BASE}/go/go-original-wordmark.svg`,
  dotnet: `${DEVICON_BASE}/dotnetcore/dotnetcore-original.svg`,
  dotnetcore: `${DEVICON_BASE}/dotnetcore/dotnetcore-original.svg`,
  netcore: `${DEVICON_BASE}/dotnetcore/dotnetcore-original.svg`,
  aspnet: `${DEVICON_BASE}/dotnetcore/dotnetcore-original.svg`,
  aspnetcore: `${DEVICON_BASE}/dotnetcore/dotnetcore-original.svg`,
  csharp: `${DEVICON_BASE}/dotnetcore/dotnetcore-original.svg`,
  fsharp: `${DEVICON_BASE}/dotnetcore/dotnetcore-original.svg`,
  javascript: '/images/JavaScript.png',
  js: '/images/JavaScript.png',
};

function normalizeTechnologyKey(value: string): string {
  return (value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

export function getTechnologyImage(technology?: string): string | undefined {
  if (!technology) return undefined;

  const normalized = normalizeTechnologyKey(technology);
  if (!normalized) return undefined;

  const exactMatch = TECHNOLOGY_IMAGE_BY_KEY[normalized];
  if (exactMatch) return exactMatch;

  for (const [key, imagePath] of Object.entries(TECHNOLOGY_IMAGE_BY_KEY)) {
    if (key.length < 4) continue;
    if (normalized.includes(key) || key.includes(normalized)) return imagePath;
  }

  return undefined;
}
